var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-tour w-full" }, [
    _c("div", [
      _c(
        "div",
        {
          staticClass: "modal",
          class: "aa" + this.id,
          attrs: {
            "data-feature": "modal",
            "data-name": "appointment_signup_" + this.id + this.type
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal__content",
              attrs: { "data-feature": "modal-active-area" }
            },
            [
              _c("div", {}, [
                _c("h3", { staticClass: "panel__title" }, [
                  _vm._v(_vm._s(_vm.appointmentTitle))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel__paragraph" }, [
                  _vm._v(_vm._s(_vm.localAppointmentParagraphComputed))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel__paragraph" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "theme-btn theme-btn--block theme-btn--primary signup-button",
                      on: { click: _vm.signUp }
                    },
                    [_vm._v(_vm._s(_vm.appointmentButton))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          class: "bb" + this.id,
          attrs: {
            "data-feature": "modal",
            "data-name": "appointment_reservelist_signup_" + this.id + this.type
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal__content",
              attrs: { "data-feature": "modal-active-area" }
            },
            [
              _c("div", {}, [
                _c("h3", { staticClass: "panel__title" }, [
                  _vm._v(_vm._s(_vm.appointmentReservelistTitle))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel__paragraph" }, [
                  _vm._v(_vm._s(_vm.appointmentReservelistParagraph))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel__paragraph" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "theme-btn theme-btn--block theme-btn--primary signup-button",
                      on: { click: _vm.signUp }
                    },
                    [_vm._v(_vm._s(_vm.appointmentReservelistButton))]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.isSigned
        ? _c(
            "span",
            [
              _vm.isReserve
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.locales.property &&
                            _vm.locales.property.signed_for_reservelist
                        ) +
                        "\n            "
                    )
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass:
                          "theme-btn theme-btn--destructive signout-button",
                        on: { click: _vm.signOut }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.locales.appointments &&
                                _vm.locales.appointments.sign_out
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]
            ],
            2
          )
        : _c(
            "button",
            {
              staticClass:
                "theme-btn theme-btn--block theme-btn--primary signup-button",
              class: { reservelist__button: _vm.isReserve },
              attrs: { "data-feature": "open-modal", "data-target": _vm.target }
            },
            [
              _vm.isReserve
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.appointmentReservelistListingButton) +
                        "\n            "
                    )
                  ]
                : [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.locales.property &&
                            _vm.locales.property.sign_up_for_this_viewing
                        ) +
                        "\n            "
                    )
                  ]
            ],
            2
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75902966", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75902966","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeTour.vue
// module id = 626
// module chunks = 1